import { createAction, props } from '@ngrx/store';
import { CloudNormalXlat } from '../../../../core/models/cloud-normal/cloud-normal-xlat-model';

export const loadCloudNormalXlats = createAction('[Cloud Normal Facade] Load Cloud Normal Xlats');

export const loadCloudNormalXlatsSuccess = createAction(
    '[Cloud Normal Effects] Load Cloud Normal Xlats Success',
    props<{ cloudNormalXlats: Array<CloudNormalXlat> }>()
);
